import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import { Auth0Provider } from "@auth0/auth0-react";
import * as serviceWorker from './serviceWorker';

import 'materialize-css/dist/js/materialize.js';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Auth0Provider
	domain="dev-3hpuhim5.us.auth0.com"
	clientId="d98FsNigYtiNAG6kfpt2mbf9tXLfznqs"
	redirectUri={window.location.origin}
      >          
	<App />
      </Auth0Provider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
